<template>
  <div class="container mt-4">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="saveProfileInfo" class="mt-3">
        <div class="row mt-4">
          <div
            class="col-12 d-flex justify-content-between align-items-center w-100"
          >
            <div class="back-button pointer" @click="$router.go(-1)">
              <i class="fal fa-chevron-left pr-3"></i>
              <span class="d-none d-md-inline-block">
                {{ $t('GENERAL.LINK.NAVIGATE_BACK') }}</span
              >
            </div>
            <div class="save-button">
              <HMButton
                class="btn bg-coral c-white"
                :loading="isLoading"
                :disabled="invalid"
                type="submit"
              >
                {{ $t('GENERAL.BUTTON.SAVE') }}
              </HMButton>
            </div>
          </div>
        </div>
        <hr class="my-4" />
        <div class="row mt-3">
          <div class="col h1 mb-md-4">{{ $t('STUDIO.TITLE.MY_PROFILE') }}</div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.DISPLAYED_FIRST_NAME')"
              v-model="data.first_name"
              rules="required"
            />
          </div>
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.DISPLAYED_LAST_NAME_OPTIONAL')"
              v-model="data.last_name"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.LOCATION')"
              v-model="data.location"
            />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-6 mb-4">
            <div class="mb-2">
              {{ $t('COMMUNITY.TEXT.TELL_US_ABOUT_YOURSELF') }}
            </div>
            <ValidationProvider>
              <!--              <HMHTMLEditor-->
              <!--                v-model="data.description_json"-->
              <!--                :addContentText="$t('COMMUNITY.LABEL.ADD_DESCRIPTION')"-->
              <!--              />-->
              <textarea
                v-model="data.description_html"
                class="form-control"
                rows="10"
                maxlength="500"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-6 mb-4 mt-3">
            <HMS3ImageUploader
              photoType="profile"
              class="profile-photo"
              inputName="profile-s3-photo"
              :title="$t('COMMUNITY.LABEL.UPLOAD_PROFILE_PHOTO')"
              :description="
                $t('COMMUNITY.TEXT.UPLOAD_PROFILE_PHOTO_INSTRUCTIONS', {
                  width: 300,
                  height: 300,
                })
              "
              :imageDescription="$t('COMMUNITY.LABEL.PROFILE_PHOTO')"
              v-model="data.image"
              :canvaWidth="300"
              :canvaHeight="300"
              :round="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.FACEBOOK')"
              v-model="data.facebook"
              placeholder="https://"
              social-network="facebook"
            />
          </div>
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.INSTAGRAM')"
              v-model="data.instagram"
              placeholder="https://"
              social-network="instagram"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.LINKEDIN')"
              v-model="data.linkedin"
              placeholder="https://"
              social-network="linkedin"
            />
          </div>
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.TWITTER')"
              v-model="data.twitter"
              placeholder="https://"
              social-network="twitter"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.YOUTUBE')"
              v-model="data.youtube"
              placeholder="https://"
              social-network="youtube"
            />
          </div>
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.PINTEREST')"
              v-model="data.pinterest"
              placeholder="https://"
              social-network="pinterest"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.TIK_TOK')"
              v-model="data.tik_tok"
              placeholder="https://"
              social-network="tiktok"
            />
          </div>
          <div class="col-md-6">
            <HMTextInput
              :label="$t('COMMUNITY.LABEL.WEBSITE_LINK')"
              v-model="data.website"
              placeholder="https://"
            />
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { errorToMessage } from '@/core/utils/errors';
import { ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudentCommunityProfileEdit',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    ...mapGetters({
      studentCommunityProfileId: 'user/studentCommunityProfileId',
    }),
  },
  data() {
    return {
      data: {
        description_json: null,
        description_html: null,
        image: null,
        facebook: null,
        linkedin: null,
        youtube: null,
        tik_tok: null,
        instagram: null,
        twitter: null,
        pinterest: null,
        website: null,
      },
      isLoading: false,
    };
  },
  methods: {
    studioURL() {
      return getStudioURL(this.$route);
    },
    async saveProfileInfo() {
      try {
        this.isLoading = true;
        this.data = await this.$store.dispatch(
          'community/saveMyCommunityProfileData',
          this.data
        );
        await this.$store.dispatch('user/loadUserInfo');
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('COMMUNITY.TEXT.PROFILE_SUCCESSEFULLY_SAVED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(
            error.response,
            `${this.$t('COMMUNITY.TEXT.PROFILE_SAVING_ERROR')}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
    async loadUserData() {
      try {
        this.data = await this.$store.dispatch(
          'community/loadStudentCommunityProfileData'
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(
            error.response,
            `${this.$t('COMMUNITY.TEXT.PROFILE_LOADING_ERROR')}: ${error}`
          ),
          duration: -1,
        });
      }
    },
  },
  mounted() {
    this.loadUserData();
  },
});
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
@media only screen and (min-width: 768px) {
  .profile-editor {
    height: 225px;
  }

  .profile-photo {
    margin-top: 1rem;
    min-height: 270px;
  }
}
</style>
